export const SWEEP_BASE_PATH = '/:entityName/:projectName/sweeps/:sweepName';
export const SWEEP_WORKSPACE_PATH =
  '/:entityName/:projectName/sweeps/:sweepName/:tab(workspace)';

export const FULL_SCREEN_SWEEP_PANEL_PATH =
  '/:entityName/:projectName/sweeps/:sweepName/panel/:panelId';
export const FULL_SCREEN_SWEEP_WORKSPACE_TAB_PANEL_PATH =
  '/:entityName/:projectName/sweeps/:sweepName/:tab(workspace)/panel/:panelId';
export const FULL_SCREEN_SWEEP_RUN_PANEL_PATH =
  '/:entityName/:projectName/sweeps/:sweepName/:tab(runs)/:runName/panel/:panelId';
export const EMBEDDED_SWEEP_PANEL_PATH =
  '/:entityName/:projectName/sweeps/:sweepName/embed/panel/:panelId';

export const SWEEP_WORKSPACE_PATHS = [
  SWEEP_BASE_PATH,
  SWEEP_WORKSPACE_PATH,
  FULL_SCREEN_SWEEP_PANEL_PATH,
  FULL_SCREEN_SWEEP_WORKSPACE_TAB_PANEL_PATH,
  EMBEDDED_SWEEP_PANEL_PATH,
  // single-run mode paths
  '/:entityName/:projectName/sweeps/:sweepName/:tab(runs)/:runName',
  '/:entityName/:projectName/sweeps/:sweepName/:tab(runs)/:runName/:runTab',
  '/:entityName/:projectName/sweeps/:sweepName/:tab(runs)/:runName/:runTab(code|files)/:filePath*',
  FULL_SCREEN_SWEEP_RUN_PANEL_PATH,
];

export const SWEEP_PATHS = [
  ...SWEEP_WORKSPACE_PATHS,
  '/:entityName/:projectName/sweeps/:sweepName/:tab',
];
